import { styled } from '@flex-design-system/stitches-react';
import { motion } from 'framer-motion';
import { Flex } from '../layout/Flex.mjs';

const StyledToastRoot = styled(motion.div, {
  position: "fixed",
  top: 24,
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: "$TOP_OF_EVERYTHING",
  borderRadius: 10,
  padding: "12px 16px",
  color: "$white",
  lineHeight: 1.4,
  backgroundColor: "$grayDarker",
  boxShadow: "inset 0 0 0 1px rgba(0,0,0,1)"
});
const StyledRoot = styled(Flex, {
  flexShrink: 0
});
function toastTransition() {
  return {
    initial: "initial",
    animate: "animate",
    exit: "exit",
    variants: {
      initial: {
        opacity: 1,
        scale: 0.95,
        y: "-60px",
        x: "-50%"
      },
      animate: {
        opacity: 1,
        x: "-50%",
        y: 0,
        transition: {
          duration: 0.45,
          ease: [0.2, 1, 0.8, 1]
        }
      },
      exit: {
        opacity: 0,
        scale: 0.8,
        y: 2,
        transition: {
          duration: 0.45,
          ease: [0.2, 1, 0.8, 1]
        }
      }
    }
  };
}
const StyledTitleRoot = styled("div", {
  width: "max-content",
  minWidth: "0px",
  maxWidth: "400px",
  paddingRight: 8,
  display: "flex",
  wordBreak: "break-all",
  whiteSpace: "pre-line",
  wordWrap: "break-word"
});

export { StyledRoot, StyledTitleRoot, StyledToastRoot, toastTransition };
//# sourceMappingURL=styled.mjs.map
